var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "seckill-wrapper", style: _vm.outerStyle }, [
        _c(
          "div",
          { staticClass: "seckill-header acea-row row-between-wrapper" },
          [
            _c("div", { staticClass: "header-left acea-row row-middle" }, [
              _vm.titleText
                ? _c(
                    "span",
                    {
                      staticClass: "header-label",
                      style: { color: _vm.titleColorVal },
                    },
                    [_vm._v(_vm._s(_vm.titleText))]
                  )
                : _vm._e(),
              _c(
                "span",
                {
                  staticClass: "header-label",
                  style: { color: _vm.titleColorVal },
                },
                [_vm._v("距结束")]
              ),
              _vm._m(0),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "seckill-content", style: _vm.contentBoxStyle },
          [
            _c(
              "div",
              { staticClass: "banner-box" },
              [
                _c("el-image", {
                  staticClass: "banner-img",
                  attrs: { src: _vm.bannerSrc, fit: "cover" },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "product-scroll" }, [
              _c(
                "div",
                { staticClass: "product-list" },
                _vm._l(_vm.spikeList, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "product-card" },
                    [
                      _c("div", { staticClass: "product-img-wrap" }, [
                        _c(
                          "div",
                          {
                            staticClass: "product-img",
                            style: _vm.productImgStyle,
                          },
                          [
                            !item.image
                              ? _c("div", { staticClass: "empty-img" }, [
                                  _c("span", {
                                    staticClass: "iconfont icon-tu",
                                  }),
                                ])
                              : _c("el-image", {
                                  staticClass: "img-cover",
                                  attrs: { src: item.image, fit: "cover" },
                                }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.progressShow,
                                expression: "progressShow",
                              },
                            ],
                            staticClass: "progress-bar",
                          },
                          [
                            _c("span", { staticClass: "progress-text" }, [
                              _vm._v("已抢" + _vm._s(item.payRange || "0%")),
                            ]),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.nameShow,
                              expression: "nameShow",
                            },
                          ],
                          staticClass: "product-name line1",
                          style: { color: _vm.nameColorVal },
                        },
                        [_vm._v(_vm._s(item.name))]
                      ),
                      _c("div", { staticClass: "price-row" }, [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.priceShow,
                                expression: "priceShow",
                              },
                            ],
                            staticClass: "seckill-price",
                            style: { color: _vm.priceColorVal },
                          },
                          [
                            _vm._v(
                              "¥" + _vm._s(item.seckillPrice || item.price)
                            ),
                          ]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.originalPriceShow,
                                expression: "originalPriceShow",
                              },
                            ],
                            staticClass: "original-price",
                          },
                          [_vm._v("¥" + _vm._s(item.price || item.otPrice))]
                        ),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "countdown-block" }, [
      _c("span", [_vm._v("02")]),
      _c("span", { staticClass: "colon" }, [_vm._v(":")]),
      _c("span", [_vm._v("34")]),
      _c("span", { staticClass: "colon" }, [_vm._v(":")]),
      _c("span", [_vm._v("18")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }